export const iconFontAwesomeCodingBarsStaggered = (
	<i className="fa-solid fa-bars-staggered"></i>
);
